// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GAab","comment":"styles_comment__2tuik"};